import { useContext } from "react";
import HeaderPanel from "./headerPanel";
import SidePanel from "./sidePanel";
import { REQ_LOGOUT, useApi } from "../logic/classApi";
import { LoginContext } from "../context/loginContext";
import useCookie from "../logic/cookie";

interface Props {
  // 子コンポーネント
  children?: React.ReactNode;
  // ヘッダ表示有無
  showHeader?: boolean;
  // サイドバー表示有無
  showSidebar?: boolean;
  // ログアウト通知
  onLogout?: () => void;
}

/**
 * 全画面共通表示
 * @param props
 * @returns
 */
export default function CommonPage({ children, showHeader, showSidebar, onLogout }: Props) {
  const { postRequestJson } = useApi(window);
  const { setIsLogin } = useContext(LoginContext);
  const [, cookieHandle] = useCookie();

  // ログアウト操作ハンドラ
  const handleLogout = async () => {
    await postRequestJson(REQ_LOGOUT);
    cookieHandle.deleteCookies();
    setIsLogin(false);
    onLogout();
    window.history.pushState({}, "", "/");
  };

  return (
    <div className="app">
      {showHeader && <HeaderPanel onLogout={handleLogout} />}
      <div className="app-body">
        {showSidebar && <SidePanel />}
        {children}
      </div>
    </div>
  );
}
